<template>
  <div class="form-error-message">
    <type-based-transition transition-type="fadeUpDown">
      <span v-if="!formState.isValid"> <slot /> </span>
    </type-based-transition>
  </div>
</template>
<script>
import TypeBasedTransition from "../transitions/TypeBasedTransition.vue"

export default {
  name: "field-error",
  inject: ["formState"],
  components: {
    TypeBasedTransition
  }
}
</script>

<style lang="scss" scoped>
  button.form-button {
    cursor: pointer;
    color: #333;
    background: none;
    font-size: 2rem;
    transition: all .45s;

    &:hover {
      background: greenyellow;
      box-shadow: 1px 2px 5px rgba(0,0,0,0.1);
      color: green;
    }
  }
</style>